import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getAuthenticatedUser } from "api/auth.api";
import { QUERY_KEYS } from "config/queryKeys";

export const useGetLoggedInUser = () => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: QUERY_KEYS.auth.me(),
    queryFn: getAuthenticatedUser,
    initialData: () => queryClient.getQueryData(QUERY_KEYS.auth.me()),
    select: (data) => data?.user ?? null,
    staleTime: 1000 * 60 * 30,
    retry: false,
  });
};
